import { z } from 'zod';
import i18next from 'i18next';
import { equipmentDetectionSchema } from '../equipment-detection/equipment-detection.schema';

export const equipmentSchema = z
  .object({
    id: z.string().optional(),
    icon: z.string().nullish(),
    name: z.string().superRefine((data, ctx) => {
      if (!data) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18next.t('equipment:equipmentNameRequired'),
        });
      }
    }),
    color: z.string().nullish(),
    comment: z.string().nullish(),
    isMultiple: z.boolean().default(false),
    maxTimes: z
      .union([z.string(), z.number()])
      .transform((val) => parseInt(val as string, 10))
      .nullish(),
    index: z.number().nullish(),
    classId: z.number().nullish(),
    whitelistedEquipments: z.array(equipmentDetectionSchema).nullish(),
    blacklistedEquipments: z.array(equipmentDetectionSchema).nullish(),
    active: z.boolean().default(true),
    groupIds: z.array(z.string()).nullish(),
    checkPointIds: z.array(z.string()).nullish(),
    isFrontPart: z.boolean().default(false),
    isBackPart: z.boolean().default(false),
    isLeftPart: z.boolean().default(false),
    isRightPart: z.boolean().default(false),
    frontPartTranslation: z.string().optional(),
    backPartTranslation: z.string().optional(),
    leftPartTranslation: z.string().optional(),
    rightPartTranslation: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.isMultiple && !data.maxTimes) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['maxTimes'],
        message: i18next.t('equipment:numberOfMaxTimesRequired'),
      });
    }
  });

export type TEquipmentSchema = z.infer<typeof equipmentSchema>;
